<script setup>
const emit = defineEmits()
const props = defineProps({
  value: [String, Number]
})

// 选中数据和修改方法向下传递给option
const selectValue = computed(() => props.value)
const setSelectValue = value => {
  emit('input', value)
  emit('change', value)
}

provide('selectValue', selectValue)
provide('setSelectValue', setSelectValue)
</script>

<template>
  <div class="nio-select">
    <slot/>
  </div>
</template>

<style lang="scss" scoped>

</style>
